import * as React from 'react'
import { PictureProps } from '@thg-commerce/gravity-system'

import {
  Container,
  SlidesWrapper,
  SlideItem,
  ThumbnailWrapper,
  ThumbnailItem,
  StyledPicture,
  StyledTitle,
  StyledText,
} from './styles'

export interface ImageProps {
  picture: PictureProps
  thumbnail: {
    image: string
    alt: string
    text?: string
  }
}

export interface ImageSelectSliderProps {
  images: ImageProps[]
  title?: string
}

export const ImageSlider = ({ images, title }: ImageSelectSliderProps) => {
  if (!images?.length) {
    return null
  }

  const [activeSlide, setActiveSlide] = React.useState<number>(0)

  const SlideItems = React.useMemo(
    () =>
      images.map((imageProps, index) => (
        <SlideItem key={index}>
          <StyledPicture lazy={images.length > 0} {...imageProps.picture} />
        </SlideItem>
      )),
    [images],
  )

  const handleThumbnailClick = (slideItem: number) => {
    if (slideItem !== activeSlide) {
      setActiveSlide(slideItem)
    }
  }

  return (
    <Container>
      <SlidesWrapper activeSlide={activeSlide}>{SlideItems}</SlidesWrapper>
      <ThumbnailWrapper>
        {images.map((imageProps, index) => (
          <ThumbnailItem
            key={index}
            src={imageProps.thumbnail.image}
            alt={imageProps.thumbnail.alt}
            isActive={index === activeSlide}
            onClick={() => handleThumbnailClick(index)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault()
                handleThumbnailClick(index)
              }
            }}
            onMouseDown={(event) => {
              event.preventDefault()
            }}
            role="button"
            tabIndex={0}
            aria-label={imageProps.thumbnail.alt}
          />
        ))}
      </ThumbnailWrapper>
      <div style={{ textAlign: 'center' }}>
        {title && <StyledTitle>{title}</StyledTitle>}
        {images[activeSlide]?.thumbnail.text && (
          <StyledText>{images[activeSlide].thumbnail.text}</StyledText>
        )}
      </div>
    </Container>
  )
}
